import Vue from 'vue'
import Router from 'vue-router'
import { routers } from './routers';
Vue.use(Router);
// 解决二次点击路由跳转报错的问题
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: routers,
})




// WEBPACK FOOTER //
// ./src/router/index.js